const API_BASE_PATH = '/api/v1';
const URL_EVENT_PATH = `${API_BASE_PATH}/events/{{eventId}}`;
const SIGNED_ASSETS_ENDPOINT = `${URL_EVENT_PATH}/signed-asset`;
const URL_EID_PATH = `${API_BASE_PATH}/eid/{{eventId}}`;
const CONTENT_PATH = `${API_BASE_PATH}/event/{{eventId}}/contents`;
const URL_LIVESTREAM_PATH = `${URL_EVENT_PATH}/live-stream/{{liveStreamId}}`;
const STUDIO_EXPRESS_BASE_PATH = '/live-session';
const GET_LINK_BY_ROUTES_ENDPOINT = `${URL_EVENT_PATH}/accredited-link-by-routes`;
const CONTENT_HUB_PATH = `${API_BASE_PATH}/content-hubs/{{eventId}}`;
const SINGLE_SIGNED_ASSET_ENDPOINT = `${SIGNED_ASSETS_ENDPOINT}/{{docId}}/{{fileName}}`;

module.exports = {
    'event_speaker': getSpeakerRoutes,
    'event_moderator': getModeratorRoutes,
    'event_live_display': getLiveDisplayRoutes,
    'event_sponsor': getSponsorRoutes,
    'event_badge_printing_staff': getBadgePrintingStaffRoutes,
    'event_meeting_planner': getMeetingPlannerRoutes,
};

/**
 * @param {String} eventId
 * @param {String} sponsorId
 */
function getSponsorRoutes(eventId, sponsorId) {
    return [
        { method: 'GET', url: '/api/v1/events/' + eventId },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/sponsors/' + sponsorId },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/blueprint' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/i18n' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/metadata' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/settings' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/blueprint' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/i18n' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/metadata' },
        // get and update sponsor
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/sponsors/retrieve-item'},
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/sponsor/' + sponsorId},
        // installed endpoint as we need to check the 'lib-backlinks' version
        { method: 'GET', url: '/api/v1/packages/installed/event/' + eventId },
        // icon excerpt
        { method: 'GET', url: `/api/v1/events/${eventId}/document/icon/excerpt` },
        // file uploads
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/assets/file-name-to-asset-doc-id' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/assets/upload' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/background-jobs/fetch-jobs-by-doc-ids' },
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/docbyid/sponsorimg_asset.' },
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/docbyid/icon.' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docsbytype/can_asset' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/assets/can_asset/file' },
        // file preview
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/assets/sponsorimg_asset.' },
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/assets/icon.' },
        // create fp type docs
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/data/sponsorimg_asset' },
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/data/can' },
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/data/can_asset' },
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/data/person' },
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/data/icon' },
        // backlinks
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/backlinks-by-label/sponsorimg_asset'},
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/backlinks-by-label/can'},
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/backlinks-by-label/person'},
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/backlinks-by-label/icon'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/sponsorimg_asset'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/can'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/can_asset'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/person'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/icon'},
        // excerpts
        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/can/excerpt'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/person/excerpt'},
        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/sponsorimg_asset/excerpt'},
        // refresh backlinks
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/'},
        // video calls legacy
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/video-calls/schedule' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/video-calls/join' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/video-calls/cancel' },
        // video calls
        { method: 'POST', url: '/api/v1/events/' + eventId + '/video-calls/schedule' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/video-calls/migrate' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/video-calls/cancel' },
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/document/video_call/' },
        { method: 'PUT', startsWithUrl: '/api/v1/events/' + eventId + '/video-calls/' },
        // update external
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/can/' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/person/' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/sponsorimg_asset/sponsorimg_asset.' },
        // fetching person with decrypted vault
        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/paxinfo/' }
    ];
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {Object[]}
 */
function getSharedStudioRoutes(eventId, liveStreamId) {
    return [
        {
            method: 'GET',
            url: getEventPath(eventId),
        }, {
            method: 'GET',
            url: getLiveSessionPath(eventId, liveStreamId),
        }, {
            method: 'GET',
            url: getStudioPath(eventId, liveStreamId),
        }, {
            method: 'POST',
            url: `${getEidPath(eventId)}/compile/blueprint`,
        }, {
            method: 'POST',
            url: `${getEidPath(eventId)}/compile/i18n`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/docbyid/i18n`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/docbyid/blueprint`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/docbyid/theme`,
        }, {
            method: 'POST',
            url: `${getEidPath(eventId)}/compile/metadata`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/metadata`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/docbyid/settings`,
        }, {
            method: 'GET',
            url: `${getEventPath(eventId)}/document/live_stream/${liveStreamId}`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/signed-url`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/questions`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/token`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/viewers`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/reactions`,
        }, {
            method: 'POST',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/connectivity-test`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/poll`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/session-info`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/analytics-snapshot`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/background`,
        }, {
            method: 'GET',
            startsWithUrl: `${API_BASE_PATH}/packages/installed/event/${eventId}`,
        },
        // TODO: remove this getContentHubPath when we assume acc links all have getContentPath, or that we move the routes to backend
        {
            method: 'GET',
            startsWithUrl: `${getContentHubPath(eventId)}/contents`,
        }, {
            method: 'GET',
            startsWithUrl: getContentPath(eventId),
        }, {
            method: 'GET',
            startsWithUrl: `${getEventPath(eventId)}/assets`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/lower-thirds`,
        }, {
            method: 'POST',
            startsWithUrl: `${getEventPath(eventId)}/log/websocket-connection-metrics`
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/live-displays`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/studio-stage`
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/slides`
        }
    ];
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {Object[]}
 */
function getSpeakerRoutes(eventId, liveStreamId) {
    return [
        ...getSharedStudioRoutes(eventId, liveStreamId),
        {
            method: 'GET',
            startsWithUrl: `${getSharedAssetsPath(eventId)}`
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/input-switch`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/studio`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/chat`,
        }, {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/virtual-backgrounds`,
        }, {
            method: 'POST',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/change-stage`
        }, {
            method: 'POST',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/streams-proof-of-life`
        }, {
            method: 'POST',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/chat`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/slides`
        } // TODO: change this when we tackle EP-13643
    ];
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {Object[]}
 */
function getModeratorRoutes(eventId, liveStreamId) {
    return [
        ...getSpeakerRoutes(eventId, liveStreamId),
        {
            method: 'POST',
            url: GET_LINK_BY_ROUTES_ENDPOINT.replace('{{eventId}}', eventId),
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/questions`,
        }, {
            method: 'PUT',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/questions`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/poll`,
        }, {
            method: 'PUT',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/poll`,
        }, {
            method: 'DELETE',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/poll`,
        }, {
            method: 'GET',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/frame-rate`,
        }, {
            method: 'PUT',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/lower-thirds`,
        }, {
            method: 'PUT',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/poll/poll-order`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/input-switch`,
        }, {
            method: 'PUT',
            url: `${getLiveStreamPath(eventId, liveStreamId)}/input-switch/sync-videos`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/release-stage`
        }, {
            method: 'PUT',
            url: `${getLiveStreamPath(eventId, liveStreamId)}`,
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/slides`
        }, {
            method: 'POST',
            startsWithUrl: `${getEidPath(eventId)}/contents`
        }, {
            method: 'PUT',
            startsWithUrl: `${getEidPath(eventId)}/contents`
        }, {
            method: 'DELETE',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/virtual-backgrounds`,
        }
    ];
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {Object[]}
 */
function getLiveDisplayRoutes(eventId, liveStreamId) {
    return [
        ...getSharedStudioRoutes(eventId, liveStreamId),
        {
            method: 'GET',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/live-display`,
        }, {
            method: 'GET',
            startsWithUrl: `${getSingleSharedAssetPath(eventId, liveStreamId, 'index.m3u8')}`
        }, {
            method: 'POST',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/live-display`,
        }, {
            method: 'PUT',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/live-display`,
        }, {
            method: 'DELETE',
            startsWithUrl: `${getLiveStreamPath(eventId, liveStreamId)}/live-display`,
        }
    ];
}

/**
 * @param {String} eventId
 * @returns {Object[]}
 */
function getCoreBSTGRoutes(eventId) {
    return [
        { method: 'GET', url: '/api/v1/info' },

        { method: 'GET', startsWithUrl: '/api/v1/users' },
        { method: 'POST', url: '/api/v1/users/me' },
        { method: 'POST', url: '/api/v1/users/me/phone-validation' },
        { method: 'PUT', url: '/api/v1/users/me/phone' },

        { method: 'GET', startsWithUrl: '/api/v1/session' },

        { method: 'GET', url: '/api/v1/events/' + eventId },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/metadata' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/registration' },

        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/settings' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/settings_changes' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/registry' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/blueprint' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/i18n' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/metadata' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/i18n' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/settings' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/metadata' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/compile/registry' },

        { method: 'GET', regexp: new RegExp(`^/api/v1/events/${eventId}/reports/\\w+$`, 'i') },
        { method: 'GET', regexp: new RegExp(`^/api/v1/events/${eventId}/reports/\\w+/progress`, 'i') },

        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/background-jobs/fetch-jobs-by-doc-ids` },

        // images etc.
        { method: 'GET', startsWithUrl: `/api/v1/events/${eventId}/assets/` },
    ];
}


/**
 * @param {String} eventId
 * @returns {Object[]}
 */
function getExportRoutes(eventId) {
    return [
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/background-jobs/create-job` },
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/background-jobs/fetch-job-by-doc-id` },
        { method: 'POST', url: '/api/v1/convert/excel' },
        { method: 'POST', url: `/api/v1/events/${eventId}/convert/excel` },
        { method: 'GET', regexp: new RegExp('^/api/v1/task-queue/job/\\d+/status$', 'i') },
        { method: 'GET', regexp: new RegExp('^/api/v1/task-queue/job/\\d+/result$', 'i') },
        { method: 'GET', startsWithUrl: `/api/v1/eid/${eventId}/nodehandlers/background-jobs/fetch-attachment` },
    ];
}

/**
 * @param {String} eventId
 * @returns {Object[]}
 */
function getImportRoutes(eventId) {
    return [
        { method: 'GET', url: `/api/v1/events/${eventId}/cogsconfigs` },
        { method: 'POST', url: `/api/v1/checkrefs/${eventId}` },
        { method: 'POST', url: `/api/v1/eid/${eventId}/data/cogs-config` },
        { method: 'PUT', startsWithUrl: `/api/v1/eid/${eventId}/doc/cogs-config/` },

        { method: 'POST', regexp: new RegExp(`^/api/v1/events/${eventId}/appscripts/\\w+/check-before-import$`, 'i') },
    ];
}

/**
 * @param {String} eventId
 * @returns {Object[]}
 */
function getBadgePrintingStaffRoutes(eventId) {
    return [
        ...getCoreBSTGRoutes(eventId),
        ...getExportRoutes(eventId),

        ...getImportRoutes(eventId),

        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/docbyid/' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/reports/badge-printing' },

        // onsite-scan/translations
        { method: 'POST', url: '/api/v1/events/' + eventId + '/docbyid/bstg-i18n-bit' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/bstg-i18n-bit' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/i18n-bit' },

        // onsite-scan/printing
        { method: 'GET', url: '/api/v1/eid/' + eventId + '/doc/settings_changes/settings_changes' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/doc/settings_changes/settings_changes' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/contents/onsite_scanning_font/get-upload-url' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/contents/onsite_scanning_font' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/onsite_scanning_font' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_font_secondary/get-upload-url' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_font_secondary' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/onsite_badge_font_secondary' },

        // onsite-scan/kiosk
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/onsite_badge_logo' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/onsite_badge_background' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/badge_design/' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/doc/badge_design' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/badge_design' },

        // onsite-scan/branding
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docsbytype/badge_design' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/badge_design/excerpt' },

        // onsite-scan/contents
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/contents/onsite_scanning_image/get-upload-url' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_logo' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_logo' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_background' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/contents/onsite_badge_background' },

        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/onsite_scanning_image' },

        // assets-library
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docsbytype/printable_asset_item' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/printable_asset_item' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/contents/printable_asset_item/get-upload-url' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/contents/' },

        // participants
        { method: 'GET', url: '/api/v1/events/' + eventId + '/users' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/person' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/person/' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/fstg/get-model-pages-basic-info' },
        { method: 'GET', regexp: new RegExp(`^/api/v1/events/${eventId}/paxinfo/(\\w+|\\-)+$`, 'i') },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/participants/upload-photos' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/assets/upload' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/update-attendance' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/bulk-edit' },

        { method: 'POST', url: '/api/v1/event/' + eventId + '/backstage/webapp-login-url' },
        { method: 'GET', url: '/api/v1/eid/' + eventId + '/backstage/webapp-login-url' },
    ];
}

/**
 * @param {String} eventId
 * @returns {Object[]}
 */
function getMeetingPlannerRoutes(eventId) {
    return [
        ...getCoreBSTGRoutes(eventId),
        ...getExportRoutes(eventId),

        ...getImportRoutes(eventId),
        // import meetings
        { method: 'POST', regexp: new RegExp(`^/api/v1/events/${eventId}/appscripts/meetings/import-meetings$`, 'i') },
        { method: 'POST', url: `/api/v1/events/${eventId}/reports/meetings` },

        // import meeting-requests
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/meeting-requests/check-meeting-requests-before-import` },
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/meeting-requests/import-meeting-requests` },

        // import locations
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/meetings/check-locations-before-import` },
        { method: 'POST', url: `/api/v1/events/${eventId}/appscripts/meetings/import-locations` },

        // translations
        { method: 'POST', url: '/api/v1/events/' + eventId + '/docbyid/bstg-i18n-bit' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/bstg-i18n-bit' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/i18n-bit' },

        // meetings/calendar
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/locations' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/calendar' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/backlinks/person' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/get-attendees-for-picker' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/actions/check-location-availability' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/meeting' },

        { method: 'GET', url: '/api/v1/events/' + eventId + '/docbyid/metadata' },

        // meetings
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/retrieve-page' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/retrieve-item' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/attendance/get-user-attendance' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/attendance/get-user-status' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/cancel-meetings' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meetings/delete-meetings' },

        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/meeting/' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/meeting-request/' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/prospect/' },

        // meeting-requests
        { method: 'GET', url: '/api/v1/events/' + eventId + '/emailTemplates' },

        { method: 'GET', startsWithUrl: '/api/v1/events/' + eventId + '/docbyid/' },
        { method: 'GET', url: '/api/v1/events/' + eventId + '/docsbytype/meeting-request' },
        { method: 'GET', regexp: new RegExp(`^/api/v1/events/${eventId}/meeting-request/(\\w+|\\-)+/participant/(\\w+|\\-)+/inviteUrl$`, 'i') },
        { method: 'GET', regexp: new RegExp(`^/api/v1/events/${eventId}/meeting-request/(\\w+|\\-)+/representative/blocked-slots$`, 'i') },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meeting-requests/reject-request' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meeting-requests/request-availability' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/meeting-requests/meeting-scheduled' },

        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/meeting-request' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/meeting-request' },

        { method: 'GET', url: '/api/v1/eid/' + eventId + '/scheduled-mailings' },
        { method: 'POST', startsWithUrl: '/api/v1/eid/' + eventId + '/email/template/' },

        // prospects
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/prospect' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/prospect' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/prospects/retrieve-page' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/appscripts/prospects/retrieve-item' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/targeted-participants' },

        // meetings/settings
        { method: 'GET', url: '/api/v1/eid/' + eventId + '/doc/settings_changes/settings_changes' },
        { method: 'PUT', url: '/api/v1/eid/' + eventId + '/doc/settings_changes/settings_changes' },

        { method: 'GET', url: '/api/v1/events/' + eventId + '/docsbytype/meeting_location' },
        { method: 'POST', url: '/api/v1/eid/' + eventId + '/data/meeting_location' },
        { method: 'DELETE', url: '/api/v1/eid/' + eventId + '/data/meeting_location' },
        { method: 'PUT', startsWithUrl: '/api/v1/eid/' + eventId + '/doc/meeting_location/' },

        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/prospect/excerpt' },
        { method: 'POST', url: '/api/v1/events/' + eventId + '/document/meeting_location/excerpt' },
    ];
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {String}
 */
function getLiveSessionPath(eventId, liveStreamId) {
    return `${STUDIO_EXPRESS_BASE_PATH}/${eventId}/${liveStreamId}`;
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {String}
 */
function getStudioPath(eventId, liveStreamId) {
    return `${getLiveSessionPath(eventId, liveStreamId)}/studio`;
}

/**
 * @param {String} eventId
 * @returns {String}
 */
function getEidPath(eventId) {
    return URL_EID_PATH.replace('{{eventId}}', eventId);
}

/**
 * @param {String} eventId
 * @returns {String}
 */
function getContentHubPath(eventId) {
    return CONTENT_HUB_PATH.replace('{{eventId}}', eventId);
}

/**
 * @param {String} eventId
 * @returns {String}
 */
function getContentPath(eventId) {
    return CONTENT_PATH.replace('{{eventId}}', eventId);
}

/**
 * @param {String} eventId
 * @param {String} liveStreamId
 * @returns {String}
 */
function getLiveStreamPath(eventId, liveStreamId) {
    return URL_LIVESTREAM_PATH.replace('{{eventId}}', eventId).replace('{{liveStreamId}}', liveStreamId);
}

/**
 * @param {String} eventId
 * @param {String} docId
 * @param {String} fileName
 * @returns {String}
 */
function getSingleSharedAssetPath(eventId, docId, fileName) {
    return SINGLE_SIGNED_ASSET_ENDPOINT
        .replace('{{eventId}}', eventId)
        .replace('{{docId}}', docId)
        .replace('{{fileName}}', fileName);
}

/**
 * @param {String} eventId
 * @returns {String}
 */
function getSharedAssetsPath(eventId) {
    return SIGNED_ASSETS_ENDPOINT
        .replace('{{eventId}}', eventId);
}

/**
 * @param {String} eventId
 * @returns {String}
 */
function getEventPath(eventId) {
    return URL_EVENT_PATH.replace('{{eventId}}', eventId);
}
